<template>
    <div class="col">

        <div id="main"
             class="col-main">
            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">

                            <div class="row">
                                <div class="col-12 col-lg-5 mb-4">
                                    <div class="alert alert-light h-100">
                                        <h5 class="has-icon-right justify-content-between">You can find Ealing Trailfinders Cricket Club at:
                                            <i class="material-icons icon-3">location_on</i></h5>
                                        <a href="https://goo.gl/maps/1mtTgADiPDM2"
                                           target="_blank"
                                           class="text-dark">
                                            <ul class="list-unstyled">
                                                <li>Trailfinders Sports Club</li>
                                                <li>Vallis Way</li>
                                                <li>West Ealing</li>
                                                <li>London</li>
                                                <li>W13 0DD</li>
                                            </ul>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-7 mb-4">
                                    <div class="alert alert-light h-100">
                                        <p>For more information and to join Ealing Trailfinders Cricket Club please
                                           email <a href="mailto:cricket@ealingtcc.com"
                                                    target="_blank"
                                                    class="text-dark">cricket@ealingtcc.com</a>
                                        </p>                          
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row row-main justify-content-center mt-0 mt-lg-5">
                <div class="col col-xl-11">

                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3626.9978795895377!2d-0.329810686580516!3d51.525438576399054!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb0a7100386e330bc!2sTrailfinders+Sports+Club!5e0!3m2!1sen!2suk!4v1547566087009"
                            width="100%"
                            height="600"
                            frameborder="0"
                            style="border:0"
                            allowfullscreen>
                    </iframe>

                </div>
            </div>

        </div>

    </div>
</template>
<script>
    export default {
        // data() {
        //     return {
        //         model: {}
        //     }
        // },
        // methods: {
        //     fetchList() {
        //         fetchUser('5e42c8d3a366ce0f8dfc4bf9')
        //             .then(response => {
        //                 this.model = response;
        //             })
        //     },
        // }
    }
</script>
<style>
</style>
